import React, { useState } from 'react';
import logo from '../../assets/logo.jpg';
import './Navbar.css';

const Navbar = () => {
  // State to track if the mobile menu is open
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Function to close menu when a link is clicked
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar-container">
      <div className="navbar-logo">
        <a href="#hero" onClick={handleLinkClick}>
          <img src={logo} alt="Om Nidhi Production Logo" />
        </a>
      </div>

      {/* Hamburger Icon - only visible on mobile */}
      <button className="navbar-toggle" onClick={toggleMenu}>
        ☰ {/* Simple hamburger icon */}
      </button>

      {/* Links - Conditionally add 'open' class */}
      <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
        <li><a href="#services" onClick={handleLinkClick}>Services</a></li>
        <li><a href="#work" onClick={handleLinkClick}>Our Work</a></li>
        <li><a href="#about" onClick={handleLinkClick}>About Us</a></li>
        <li><a href="#contact" onClick={handleLinkClick}>Contact Us</a></li>
        <li>
  <a href="/register" onClick={handleLinkClick} style={{ color: '#FFD700' }}>
    Registration
  </a>
</li>
        <li className="enquiry-link"><a href="#enquiry" onClick={handleLinkClick}>Enquire Now</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;